<script lang="ts">
  import Param from './partials/Param.svelte';
  import type { EntityParameterType } from '$shared/constants/EntityParameterType';
  import type MissingParam from '$provider/lib/apis/models/MissingParam';

  interface Props {
    hide?: boolean;
    helpText?: string;
    missingParams?: MissingParam[];
    additionalLabelParams?: string[];
    onclick?: (param: EntityParameterType) => void;
  }

  let {
    hide = false,
    helpText = '',
    missingParams = [],
    additionalLabelParams = [],
    onclick
  }: Props = $props();

  const onClickParam = (param: EntityParameterType): void => {
    onclick?.(param);
  };
</script>

<div data-cy="missingParamWarn" class="comp-missing-param-warn" class:hide>
  <div data-cy="missingParamWarn-title" class="title">Missing requirements</div>
  <div data-cy="missingParamWarn-desc" class="desc">
    The following information is required to run this verification:
  </div>
  <div class="list">
    {#each missingParams as missingParam}
      <Param {helpText} {missingParam} onclick={onClickParam} />
    {/each}
    {#each additionalLabelParams as label}
      <div class="labelParam-li">
        <div class="text">{label}</div>
      </div>
    {/each}
  </div>
</div>

<style>
  .comp-missing-param-warn {
    background-color: var(--yellow-light);
    padding: 16px 16px;
    box-shadow: 1px 10px 15px -10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }
  .comp-missing-param-warn.hide {
    display: none;
  }
  .title {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    color: var(--yellow-dark);
  }
  .desc {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
    margin-bottom: 8px;
  }
  .list {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .labelParam-li {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    position: relative;
    padding-left: 16px;
    color: var(--blue);
    margin-bottom: 4px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .list .labelParam-li {
    color: var(--grey-dark);
  }
  .list .labelParam-li::before {
    content: '';
    width: 5px;
    height: 5px;
    background-color: var(--grey-dark);
    border-radius: 50%;
    position: absolute;
    top: 8px;
    left: 0;
  }
</style>
